import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import Modal from "react-modal";
import ImageUploading from "react-images-uploading";
import { formatDateTime } from "../../common-data/Converts";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import { getReplace1 } from "../../common-data/Conversions";
import { NoPic } from "../../../exports/Images";
import { commonPostPutApi } from "../../../redux/reducers/commonApiSlice";
import { uploadImage } from "../../../redux/reducers/postApiSlice";
import {
  approve_reject_expense_request,
  pay_expense_request,
} from "../../../data/ApiEndpoints";
import "../../../styles/expense-management/detail-expense-listing.css";

const DetailsExpenseListing = ({
  row,
  userInfoData,
  isExpenseManager,
  setModValues: setParentModValues,
  callFunction,
}) => {
  const dispatch = useDispatch();

  const isPDF =
    row?.requested_img && row.requested_img?.toLowerCase().endsWith(".pdf")
      ? true
      : false;

  const expenseManagerRole =
    (isExpenseManager && isExpenseManager?.role_type) || null;

  const superProcessManager = isExpenseManager?.super_process_manager === 1;

  // console.log("superProcessManager", superProcessManager);

  const iniModvalues = {
    isModOpen: false,
    rowData: "",
    modName: "",
  };
  const [modValues, setModValues] = useState(iniModvalues);
  const [remarks, setRemarks] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isApproving, setIsApproving] = useState(false);
  const [showApprovalConfirmation, setShowApprovalConfirmation] =
    useState(false);
  const [showImageZoom, setShowImageZoom] = useState(false);

  // Image zoom state
  const [imageZoom, setImageZoom] = useState({
    scale: 1,
    x: 0,
    y: 0,
    isDragging: false,
    lastX: 0,
    lastY: 0,
  });

  // Image upload state and constants
  const maxNumber = 1;
  const [actionImages, setActionImages] = useState([]);
  const [uploadedImageUrl, setUploadedImageUrl] = useState("");
  const [isImageUploading, setIsImageUploading] = useState(false);

  function closeModal() {
    setModValues(iniModvalues);
  }

  // Handle approval confirmation for cluster managers and super process managers
  const handleApprovalCheckboxChange = (checked) => {
    if (
      checked &&
      (expenseManagerRole === "cluster_manager" || superProcessManager)
    ) {
      // Show confirmation modal with bill image
      setShowApprovalConfirmation(true);
    } else {
      setIsApproving(checked);
    }
  };

  const confirmApproval = () => {
    setIsApproving(true);
    setShowApprovalConfirmation(false);
  };

  const cancelApproval = () => {
    setIsApproving(false);
    setShowApprovalConfirmation(false);
  };

  // Handle image zoom modal
  const openImageZoom = () => {
    setShowImageZoom(true);
    // Reset zoom state when opening
    setImageZoom({
      scale: 1,
      x: 0,
      y: 0,
      isDragging: false,
      lastX: 0,
      lastY: 0,
    });
  };

  const closeImageZoom = () => {
    setShowImageZoom(false);
    // Reset zoom state when closing
    setImageZoom({
      scale: 1,
      x: 0,
      y: 0,
      isDragging: false,
      lastX: 0,
      lastY: 0,
    });
  };

  // Image zoom handlers
  const handleImageWheel = (e) => {
    e.preventDefault();
    const delta = e.deltaY > 0 ? 0.9 : 1.1;
    const newScale = Math.min(Math.max(imageZoom.scale * delta, 0.5), 5);

    setImageZoom((prev) => ({
      ...prev,
      scale: newScale,
    }));
  };

  const handleImageMouseDown = (e) => {
    e.preventDefault();
    setImageZoom((prev) => ({
      ...prev,
      isDragging: true,
      lastX: e.clientX,
      lastY: e.clientY,
    }));
  };

  const handleImageMouseMove = (e) => {
    if (!imageZoom.isDragging) return;

    const deltaX = e.clientX - imageZoom.lastX;
    const deltaY = e.clientY - imageZoom.lastY;

    setImageZoom((prev) => ({
      ...prev,
      x: prev.x + deltaX,
      y: prev.y + deltaY,
      lastX: e.clientX,
      lastY: e.clientY,
    }));
  };

  const handleImageMouseUp = () => {
    setImageZoom((prev) => ({
      ...prev,
      isDragging: false,
    }));
  };

  const handleImageDoubleClick = () => {
    setImageZoom({
      scale: 1,
      x: 0,
      y: 0,
      isDragging: false,
      lastX: 0,
      lastY: 0,
    });
  };

  // Image upload handlers
  const handleImageChange = (imageList) => {
    setActionImages(imageList);

    if (imageList.length > 0) {
      setIsImageUploading(true);
      imageList.forEach(async (image) => {
        const blob = await fetch(image?.data_url).then((res) => res.blob());
        const file = new File([blob], "action-image.jpeg", {
          type: "image/jpeg",
        });
        handleUploadImage(file);
      });
    } else {
      setUploadedImageUrl("");
    }
  };

  const handleUploadImage = async (file) => {
    try {
      const actionResult = dispatch(
        uploadImage({ file, TOKEN: userInfoData?.token })
      );
      const result = await actionResult;

      if (result?.payload?.status) {
        setUploadedImageUrl(
          result?.payload?.image_url || result?.payload?.data?.url || ""
        );
        toast.success(
          result?.payload?.message || "Image uploaded successfully!"
        );
      } else {
        const errorMessage = result?.error?.message || result?.payload?.message;
        toast.error(errorMessage || "Image upload failed!");
      }
    } catch (error) {
      console.error("Image upload error:", error);
      toast.error("Image upload failed!");
    } finally {
      setIsImageUploading(false);
    }
  };

  // Validation function to check if action can be performed
  const canPerformAction = (action) => {
    // Check if remarks are valid
    if (!remarks.trim() || remarks.trim().length < 10) {
      return false;
    }

    // Check if currently submitting or uploading
    if (isSubmitting || isImageUploading) {
      return false;
    }

    // For cluster manager or super process manager, require checkbox to be checked for approve actions
    if (
      (expenseManagerRole === "cluster_manager" || superProcessManager) &&
      action !== "reject" &&
      (action === "approve" ||
        action === "approve_and_pay" ||
        action === "approve_only") &&
      !isApproving
    ) {
      return false;
    }

    // Image validation for pay actions
    if (
      (action === "pay" || action === "approve_and_pay") &&
      !uploadedImageUrl
    ) {
      return false;
    }

    // For cluster manager or super process manager approval or payment, ensure payment image is uploaded
    if (
      (expenseManagerRole === "cluster_manager" || superProcessManager) &&
      (action === "approve_and_pay" || action === "pay") &&
      !uploadedImageUrl
    ) {
      return false;
    }

    return true;
  };

  const handleApproveRejectPay = async (action) => {
    if (!remarks.trim()) {
      toast.error("Please enter remarks before proceeding.");
      return;
    }

    if (remarks.trim().length < 10) {
      toast.error("Remarks must be at least 10 characters long.");
      return;
    }

    // For cluster manager or super process manager, require checkbox to be checked ONLY for pending requests (approve & pay)
    if (
      (expenseManagerRole === "cluster_manager" || superProcessManager) &&
      action !== "reject" &&
      (action === "approve" || action === "approve_and_pay") &&
      !isApproving
    ) {
      toast.error("Please confirm your approval by checking the checkbox.");
      return;
    }

    // Image validation ONLY for pay action (not for reject)
    if (action === "pay" && !uploadedImageUrl) {
      toast.error("Please upload an image for this action.");
      return;
    }

    // For cluster manager or super process manager approval or payment, ensure payment image is uploaded
    // Only required for approve_and_pay and pay actions, not for approve_only
    if (
      (expenseManagerRole === "cluster_manager" || superProcessManager) &&
      (action === "approve_and_pay" || action === "pay") &&
      !uploadedImageUrl
    ) {
      toast.error(
        "Please upload payment proof image / Kripya payment ki photo upload kare"
      );
      return;
    }

    setIsSubmitting(true);

    const method = "POST";
    const endpoint =
      action === "pay" || expenseManagerRole === "accountant"
        ? pay_expense_request
        : approve_reject_expense_request;
    const token = userInfoData?.token || "";

    // Special payload for cluster manager or super process manager
    const isClusterManagerFlow =
      expenseManagerRole === "cluster_manager" || superProcessManager;
    const payload = isClusterManagerFlow
      ? {
          expense_id: row?.uid || "",
          status:
            action === "approve_only"
              ? "approved_notpaid"
              : action === "approve_and_pay" || action === "approve"
              ? "approved_paid"
              : action === "pay"
              ? "approved_paid"
              : "rejected",
          aprv_rej_description: remarks,
          paid_image:
            action === "approve_and_pay" ||
            action === "approve" ||
            action === "pay"
              ? uploadedImageUrl
              : "",
          aprv_rej_by: userInfoData?.uid || userInfoData?.user_id || "",
          is_approve_and_pay:
            action === "approve_and_pay" || action === "approve" ? 1 : 0,
          is_approved:
            action === "approve_only" ||
            action === "approve_and_pay" ||
            action === "approve"
              ? 1
              : 0,
        }
      : {
          aprv_rej_by:
            action !== "pay" && expenseManagerRole !== "accountant"
              ? userInfoData?.uid || userInfoData?.user_id || ""
              : "",
          paid_by:
            action === "pay" || expenseManagerRole === "accountant"
              ? userInfoData?.uid || userInfoData?.user_id || ""
              : "",
          expense_id: row?.uid || "",
          aprv_rej_description:
            action !== "pay" && expenseManagerRole !== "accountant"
              ? remarks || ""
              : "",
          paid_description:
            action === "pay" || expenseManagerRole === "accountant"
              ? remarks || ""
              : "",
          status:
            action === "approve"
              ? "approved_notpaid"
              : action === "pay"
              ? "approved_paid"
              : action === "reject" && expenseManagerRole === "accountant"
              ? "rejected_by_acc"
              : action === "reject"
              ? "rejected"
              : "",
          paid_image: action === "pay" ? uploadedImageUrl : "",
          reject_image: "", // Remove reject_image requirement
        };

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        setIsSubmitting(false);

        // Capture current values before clearing state
        const currentRemarks = remarks;
        const currentUploadedImageUrl = uploadedImageUrl;

        setRemarks(""); // Clear remarks after successful action
        setActionImages([]); // Clear uploaded images
        setUploadedImageUrl(""); // Clear uploaded image URL
        setIsApproving(false); // Reset approval checkbox

        // Update the modal's row data with new status and other fields
        const updatedRowData = {
          ...row,
          status: payload.status,
          aprv_rej_by_name:
            action !== "pay" && expenseManagerRole !== "accountant"
              ? userInfoData?.name || ""
              : row?.aprv_rej_by_name,
          aprv_rej_description:
            action !== "pay" && expenseManagerRole !== "accountant"
              ? currentRemarks
              : row?.aprv_rej_description,
          aprv_rej_date:
            action !== "pay" && expenseManagerRole !== "accountant"
              ? new Date().toISOString()
              : row?.aprv_rej_date,
          paid_by_name:
            action === "pay" || expenseManagerRole === "accountant"
              ? userInfoData?.name || ""
              : row?.paid_by_name,
          paid_by_mobile:
            action === "pay" || expenseManagerRole === "accountant"
              ? userInfoData?.mobile || ""
              : row?.paid_by_mobile,
          paid_by_email:
            action === "pay" || expenseManagerRole === "accountant"
              ? userInfoData?.email || ""
              : row?.paid_by_email,
          paid_description:
            action === "pay" || expenseManagerRole === "accountant"
              ? currentRemarks
              : row?.paid_description,
          paid_date:
            action === "pay" || expenseManagerRole === "accountant"
              ? new Date().toISOString()
              : row?.paid_date,
          paid_img: action === "pay" ? currentUploadedImageUrl : row?.paid_img,
          reject_img: "",
        };

        // Update the parent modal's rowData
        if (setParentModValues) {
          setParentModValues((prevs) => ({
            ...prevs,
            rowData: updatedRowData,
          }));
        }

        toast.success(result?.payload?.message || "Success!");
        if (callFunction) {
          callFunction(); // Refresh the data
        }
      } else {
        setIsSubmitting(false);
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      setIsSubmitting(false);
      console.error("Error making API request:", error);
      toast.error("An error occurred. Please try again.");
    }
  };

  // Helper function to get status color and info
  const getStatusInfo = (status) => {
    const planStatus = status?.replace(/ /g, "_")?.toLowerCase();
    switch (planStatus) {
      case "approved_paid":
        return {
          color: "#10b981",
          bgColor: "#d1fae5",
          icon: "✓",
          label: "Approved & Paid",
          description: "Payment has been completed",
        };
      case "approved_notpaid":
        return {
          color: "#3b82f6",
          bgColor: "#dbeafe",
          icon: "⏳",
          label: "Approved",
          description: "Awaiting payment processing",
        };
      case "pending":
        return {
          color: "#f59e0b",
          bgColor: "#fef3c7",
          icon: "⏰",
          label: "Pending Review",
          description: "Waiting for approval",
        };
      case "rejected":
      case "rejected_by_acc":
        return {
          color: "#ef4444",
          bgColor: "#fee2e2",
          icon: "✗",
          label: "Rejected",
          description: "Request has been declined",
        };
      default:
        return {
          color: "#6b7280",
          bgColor: "#f3f4f6",
          icon: "?",
          label: "Unknown",
          description: "Status unclear",
        };
    }
  };

  const statusInfo = getStatusInfo(row?.status);

  // Mobile detection
  const isMobile = window.innerWidth <= 768;

  return (
    <>
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={closeModal}
        contentLabel="Detail Modal"
        ariaHideApp={false}
        style={{
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            zIndex: 1000,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          },
          content: {
            position: "relative",
            border: "none",
            borderRadius: "12px",
            padding: "0",
            maxWidth: "90vw",
            maxHeight: "90vh",
            overflow: "auto",
            top: "auto",
            left: "auto",
            right: "auto",
            bottom: "auto",
            transform: "none",
            margin: "0",
          },
        }}
      >
        <div className="detail-expense-listing__modal-content">
          <ModalHeadAndClose
            title={`${getReplace1(modValues.modName)}`}
            onClose={closeModal}
          />

          {modValues.modName === "generated_bill_image" ||
          modValues.modName === "payment_done_image" ? (
            <div className="detail-expense-listing__modal-image-container">
              <img
                src={modValues.image}
                alt="bill"
                className="detail-expense-listing__modal-image"
              />
            </div>
          ) : modValues.modName === "description" ? (
            <div className="detail-expense-listing__modal-description-container">
              <div
                className="detail-expense-listing__modal-description-content"
                dangerouslySetInnerHTML={{
                  __html: modValues.description || "No Content Available",
                }}
              />
            </div>
          ) : null}
        </div>
      </Modal>

      {/* Approval Confirmation Modal for Cluster Manager */}
      <Modal
        isOpen={showApprovalConfirmation}
        onRequestClose={cancelApproval}
        contentLabel="Approval Confirmation"
        ariaHideApp={false}
        style={{
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            zIndex: 1001,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "20px",
          },
          content: {
            position: "relative",
            border: "none",
            borderRadius: "16px",
            padding: "0",
            maxWidth: "min(90vw, 600px)",
            maxHeight: "85vh",
            overflow: "hidden",
            top: "auto",
            left: "auto",
            right: "auto",
            bottom: "auto",
            transform: "none",
            margin: "0",
            backgroundColor: "white",
            display: "flex",
            flexDirection: "column",
          },
        }}
      >
        <div className="detail-expense-listing__approval-modal">
          <div className="detail-expense-listing__approval-modal-header">
            <h3 className="detail-expense-listing__approval-modal-title">
              🔍 Approval Confirmation
            </h3>
            <button
              onClick={cancelApproval}
              className="detail-expense-listing__approval-modal-close"
              type="button"
            >
              ✕
            </button>
          </div>

          <div className="detail-expense-listing__approval-modal-content-scrollable">
            <div className="detail-expense-listing__approval-modal-info">
              <div className="detail-expense-listing__approval-modal-amount">
                Amount: ₹
                {row?.requested_amount
                  ? new Intl.NumberFormat("en-IN").format(row.requested_amount)
                  : "0"}
              </div>
              <div className="detail-expense-listing__approval-modal-category">
                Category: {row?.expense_category_name || "N/A"}
              </div>
              <div className="detail-expense-listing__approval-modal-requester">
                Requested by: {row?.requested_by_name || "N/A"}
              </div>
            </div>

            {row?.requested_img && (
              <div className="detail-expense-listing__approval-modal-image-section">
                <h4 className="detail-expense-listing__approval-modal-image-title">
                  📋 Bill/Receipt for Review:
                </h4>
                <div className="detail-expense-listing__approval-modal-image-container">
                  {isPDF ? (
                    <div className="detail-expense-listing__approval-modal-pdf">
                      <div className="detail-expense-listing__approval-modal-pdf-icon">
                        📄
                      </div>
                      <a
                        href={row?.requested_img}
                        target="_blank"
                        rel="noreferrer"
                        className="detail-expense-listing__approval-modal-pdf-link"
                      >
                        View PDF Document
                      </a>
                    </div>
                  ) : (
                    <div>
                      <img
                        src={row?.requested_img}
                        alt="Bill for approval"
                        className="detail-expense-listing__approval-modal-image"
                        onClick={openImageZoom}
                        style={{ cursor: "pointer" }}
                        title="Click to zoom image"
                      />
                      <div className="detail-expense-listing__approval-modal-zoom-hint">
                        🔍 Click image to zoom for detailed view
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>

          <div className="detail-expense-listing__approval-modal-footer">
            <div className="detail-expense-listing__approval-modal-confirmation">
              <div className="detail-expense-listing__approval-modal-question">
                {row?.is_petty_cash === 1
                  ? "❓ Do you confirm this petty cash request for approval and payment?"
                  : "❓ Have you reviewed the bill/receipt and confirm this expense request for approval and payment?"}
              </div>

              <div className="detail-expense-listing__approval-modal-actions">
                <button
                  onClick={confirmApproval}
                  className="btn btn-success detail-expense-listing__approval-modal-confirm"
                  type="button"
                >
                  ✅ Yes, I approve this expense
                </button>
                <button
                  onClick={cancelApproval}
                  className="btn btn-secondary detail-expense-listing__approval-modal-cancel"
                  type="button"
                >
                  ❌ Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>

      {/* Image Zoom Modal */}
      <Modal
        isOpen={showImageZoom}
        onRequestClose={closeImageZoom}
        contentLabel="Image Zoom"
        ariaHideApp={false}
        style={{
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.95)",
            zIndex: 1002,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "0",
          },
          content: {
            position: "relative",
            border: "none",
            borderRadius: "8px",
            padding: "0",
            width: "100vw",
            height: "100vh",
            overflow: "hidden",
            top: "auto",
            left: "auto",
            right: "auto",
            bottom: "auto",
            transform: "none",
            margin: "0",
            backgroundColor: "transparent",
            display: "flex",
            flexDirection: "column",
          },
        }}
      >
        <div className="detail-expense-listing__zoom-modal">
          <div className="detail-expense-listing__zoom-modal-header">
            <h3 className="detail-expense-listing__zoom-modal-title">
              📋 Bill/Receipt - Detailed View
            </h3>
            <button
              onClick={closeImageZoom}
              className="detail-expense-listing__zoom-modal-close"
              type="button"
            >
              ✕
            </button>
          </div>

          <div className="detail-expense-listing__zoom-modal-content">
            {row?.requested_img && (
              <div
                className="detail-expense-listing__zoom-image-container"
                onWheel={handleImageWheel}
                onMouseMove={handleImageMouseMove}
                onMouseUp={handleImageMouseUp}
                onMouseLeave={handleImageMouseUp}
              >
                <img
                  src={row.requested_img}
                  alt="Bill for detailed review"
                  className="detail-expense-listing__zoom-image"
                  onMouseDown={handleImageMouseDown}
                  onDoubleClick={handleImageDoubleClick}
                  style={{
                    transform: `translate(${imageZoom.x}px, ${imageZoom.y}px) scale(${imageZoom.scale})`,
                    cursor: imageZoom.isDragging
                      ? "grabbing"
                      : imageZoom.scale > 1
                      ? "grab"
                      : "zoom-in",
                  }}
                  draggable={false}
                />
              </div>
            )}
          </div>

          <div className="detail-expense-listing__zoom-modal-controls">
            <div className="detail-expense-listing__zoom-instructions">
              💡 Use mouse wheel to zoom • Click and drag to pan • Double-click
              to reset
            </div>
            <button
              onClick={closeImageZoom}
              className="detail-expense-listing__zoom-close-btn"
              type="button"
            >
              Close
            </button>
          </div>
        </div>
      </Modal>

      <div className="detail-expense-listing__container">
        <div className="detail-expense-listing__header">
          <div className="detail-expense-listing__header-pattern"></div>
          <div className="detail-expense-listing__header-content">
            <div className="detail-expense-listing__header-text">
              <h2 className="detail-expense-listing__title">
                Expense Request Details
              </h2>
              <div className="detail-expense-listing__amount">
                ₹
                {row?.requested_amount
                  ? new Intl.NumberFormat("en-IN").format(row.requested_amount)
                  : "0"}
              </div>
            </div>
            <div className="detail-expense-listing__badge">
              <span>{statusInfo.icon}</span>
              {statusInfo.label}
            </div>
          </div>
        </div>

        <div className="detail-expense-listing__content">
          <div className="detail-expense-listing__section">
            <div className="detail-expense-listing__label">
              📝 Request Details
            </div>
            <div className="detail-expense-listing__value">
              {row?.requested_description && (
                <div className="detail-expense-listing__description">
                  <div
                    className="detail-expense-listing__description-content"
                    dangerouslySetInnerHTML={{
                      __html: row.requested_description,
                    }}
                  />
                </div>
              )}
              <div className="detail-expense-listing__grid--two-column">
                <div className="detail-expense-listing__info-row">
                  <span className="detail-expense-listing__info-label">
                    Category
                  </span>
                  <span className="detail-expense-listing__info-value">
                    {row?.expense_category_name || "N/A"}
                  </span>
                </div>
                <div className="detail-expense-listing__info-row">
                  <span className="detail-expense-listing__info-label">
                    Type
                  </span>
                  <span className="detail-expense-listing__info-value">
                    {row?.expense_type || "N/A"}
                  </span>
                </div>
                <div className="detail-expense-listing__info-row">
                  <span className="detail-expense-listing__info-label">
                    Requested By
                  </span>
                  <span className="detail-expense-listing__info-value">
                    {row?.requested_by_name || "N/A"}
                  </span>
                </div>
                <div className="detail-expense-listing__info-row">
                  <span className="detail-expense-listing__info-label">
                    Date
                  </span>
                  <span className="detail-expense-listing__info-value">
                    {row?.requested_date
                      ? formatDateTime(row.requested_date)
                      : "N/A"}
                  </span>
                </div>
              </div>
              {row?.requested_by_account_type && (
                <div className="detail-expense-listing__grid">
                  <div className="detail-expense-listing__info-row">
                    <span className="detail-expense-listing__info-label">
                      Account Type
                    </span>
                    <span className="detail-expense-listing__info-value">
                      👤 {row.requested_by_account_type}
                    </span>
                  </div>
                </div>
              )}
            </div>
          </div>

          {row?.is_petty_cash !== 1 && (
            <div className="detail-expense-listing__compact-section">
              <div className="detail-expense-listing__label">
                🧾 Bill Attachment
              </div>
              <div className="detail-expense-listing__value">
                {isPDF ? (
                  <a
                    href={row?.requested_img}
                    target="_blank"
                    rel="noreferrer"
                    className="detail-expense-listing__link"
                  >
                    View PDF Document
                  </a>
                ) : row?.requested_img ? (
                  <img
                    src={row?.requested_img || NoPic}
                    alt="Bill"
                    className="detail-expense-listing__image"
                    onClick={() => {
                      setModValues((prevs) => ({
                        ...prevs,
                        isModOpen: true,
                        modName: "generated_bill_image",
                        image: row?.requested_img || NoPic,
                        rowData: row,
                      }));
                    }}
                  />
                ) : (
                  <div className="detail-expense-listing__no-attachment">
                    No bill attachment available
                  </div>
                )}
              </div>
            </div>
          )}

          <div className="detail-expense-listing__compact-section">
            <div className="detail-expense-listing__label">
              💳 Payment Information
            </div>
            <div className="detail-expense-listing__value">
              <div className="detail-expense-listing__grid">
                <div className="detail-expense-listing__info-row">
                  <span className="detail-expense-listing__info-label">
                    Method
                  </span>
                  <span className="detail-expense-listing__info-value">
                    {row?.payment_method || "N/A"}
                  </span>
                </div>
                {row?.payment_method === "bank" && (
                  <>
                    <div className="detail-expense-listing__info-row">
                      <span className="detail-expense-listing__info-label">
                        Account
                      </span>
                      <span className="detail-expense-listing__info-value">
                        {row?.account_number || "N/A"}
                      </span>
                    </div>
                    <div className="detail-expense-listing__info-row">
                      <span className="detail-expense-listing__info-label">
                        IFSC
                      </span>
                      <span className="detail-expense-listing__info-value">
                        {row?.ifsc_code || "N/A"}
                      </span>
                    </div>
                  </>
                )}
                {row?.payment_method === "upi" && (
                  <div className="detail-expense-listing__info-row">
                    <span className="detail-expense-listing__info-label">
                      UPI ID
                    </span>
                    <span className="detail-expense-listing__info-value">
                      {row?.upi_id || "N/A"}
                    </span>
                  </div>
                )}
              </div>
              {row?.payment_method_img && (
                <div className="detail-expense-listing__image-container">
                  <img
                    src={row?.payment_method_img || NoPic}
                    alt="Payment Method"
                    className="detail-expense-listing__image"
                    onClick={() => {
                      setModValues((prevs) => ({
                        ...prevs,
                        isModOpen: true,
                        modName: "generated_bill_image",
                        image: row?.payment_method_img,
                        rowData: row,
                      }));
                    }}
                  />
                </div>
              )}
            </div>
          </div>

          {row?.payee_type === "vendor" && (
            <div className="detail-expense-listing__compact-section">
              <div className="detail-expense-listing__label">
                🏪 Vendor Payment Details
              </div>
              <div className="detail-expense-listing__value">
                <div className="detail-expense-listing__grid">
                  <div className="detail-expense-listing__info-row">
                    <span className="detail-expense-listing__info-label">
                      Vendor Name
                    </span>
                    <span className="detail-expense-listing__info-value">
                      {row?.vendor_name || "N/A"}
                    </span>
                  </div>
                  <div className="detail-expense-listing__info-row">
                    <span className="detail-expense-listing__info-label">
                      Contact
                    </span>
                    <span className="detail-expense-listing__info-value">
                      {row?.vendor_mobile || "No contact"}
                    </span>
                  </div>
                  <div className="detail-expense-listing__info-row">
                    <span className="detail-expense-listing__info-label">
                      Payment Status
                    </span>
                    <span className="detail-expense-listing__info-value">
                      <span className="detail-expense-listing__badge">
                        {row?.vendor_paid_status === "paid" ? "✓" : "⏳"}
                        {row?.vendor_paid_status === "paid"
                          ? "Completed"
                          : "Pending"}
                      </span>
                    </span>
                  </div>
                </div>
                {row?.vendor_paid_img && (
                  <div className="detail-expense-listing__image-container">
                    <img
                      src={row?.vendor_paid_img || NoPic}
                      alt="Vendor Payment Proof"
                      className="detail-expense-listing__image"
                      onClick={() => {
                        setModValues((prevs) => ({
                          ...prevs,
                          isModOpen: true,
                          modName: "generated_bill_image",
                          image: row?.vendor_paid_img,
                          rowData: row,
                        }));
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
          )}

          <div className="detail-expense-listing__section">
            <div className="detail-expense-listing__label">
              🔄 Approval Workflow
            </div>
            <div className="detail-expense-listing__value">
              <div className="detail-expense-listing__compact-section">
                <div className="detail-expense-listing__label">
                  👨‍💼 Approval Manager
                </div>
                <div className="detail-expense-listing__grid">
                  <div className="detail-expense-listing__info-row">
                    <span className="detail-expense-listing__info-label">
                      Name
                    </span>
                    <span className="detail-expense-listing__info-value">
                      {row?.approval_manager_name || "Not assigned"}
                    </span>
                  </div>
                  {row?.approval_manager_mobile && (
                    <div className="detail-expense-listing__info-row">
                      <span className="detail-expense-listing__info-label">
                        Contact
                      </span>
                      <span className="detail-expense-listing__info-value">
                        {row.approval_manager_mobile}
                      </span>
                    </div>
                  )}
                </div>
              </div>

              {row?.aprv_rej_by_name && (
                <div className="detail-expense-listing__compact-section">
                  <div className="detail-expense-listing__label">
                    {(() => {
                      const planStatus = row?.status
                        ?.replace(/ /g, "_")
                        ?.toLowerCase();
                      switch (planStatus) {
                        case "approved_paid":
                        case "approved_notpaid":
                          return "✅ Approved By";
                        case "rejected":
                          return "❌ Rejected By";
                        default:
                          return "✅ Approved/Rejected By";
                      }
                    })()}
                  </div>
                  <div className="detail-expense-listing__grid">
                    <div className="detail-expense-listing__info-row">
                      <span className="detail-expense-listing__info-label">
                        Name
                      </span>
                      <span className="detail-expense-listing__info-value">
                        {row.aprv_rej_by_name}
                      </span>
                    </div>
                    {row?.aprv_rej_date && (
                      <div className="detail-expense-listing__info-row">
                        <span className="detail-expense-listing__info-label">
                          Date
                        </span>
                        <span className="detail-expense-listing__info-value">
                          {formatDateTime(row.aprv_rej_date)}
                        </span>
                      </div>
                    )}
                  </div>
                  {row?.aprv_rej_description && (
                    <div className="detail-expense-listing__description">
                      "{row.aprv_rej_description}"
                    </div>
                  )}
                </div>
              )}

              {row?.paid_by_name && (
                <div className="detail-expense-listing__compact-section">
                  <div className="detail-expense-listing__label">
                    💰 Payment Processed By
                  </div>
                  <div className="detail-expense-listing__grid">
                    <div className="detail-expense-listing__info-row">
                      <span className="detail-expense-listing__info-label">
                        Name
                      </span>
                      <span className="detail-expense-listing__info-value">
                        {row.paid_by_name}
                      </span>
                    </div>
                    {row?.paid_by_mobile && (
                      <div className="detail-expense-listing__info-row">
                        <span className="detail-expense-listing__info-label">
                          Contact
                        </span>
                        <span className="detail-expense-listing__info-value">
                          {row.paid_by_mobile}
                        </span>
                      </div>
                    )}
                    {row?.paid_date && (
                      <div className="detail-expense-listing__info-row">
                        <span className="detail-expense-listing__info-label">
                          Date
                        </span>
                        <span className="detail-expense-listing__info-value">
                          {formatDateTime(row.paid_date)}
                        </span>
                      </div>
                    )}
                  </div>
                  {row?.paid_description && (
                    <div className="detail-expense-listing__description">
                      "{row.paid_description}"
                    </div>
                  )}
                  {row?.paid_img && (
                    <div className="detail-expense-listing__image-container">
                      <img
                        src={row.paid_img}
                        alt="Payment Proof"
                        className="detail-expense-listing__image"
                        onClick={() => {
                          setModValues((prevs) => ({
                            ...prevs,
                            isModOpen: true,
                            modName: "payment_done_image",
                            image: row.paid_img,
                            rowData: row,
                          }));
                        }}
                      />
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>

        {isExpenseManager &&
          (() => {
            const planStatus = row?.status?.replace(/ /g, "_")?.toLowerCase();

            const isApproved =
              planStatus === "approved_notpaid" ||
              planStatus === "approved_paid";
            const isRejected =
              planStatus === "rejected" || planStatus === "rejected_by_acc";
            const isPaid = planStatus === "approved_paid";
            const isPending = planStatus === "pending";

            const canInitialApprove =
              (expenseManagerRole === "approval_manager" &&
                isPending &&
                row?.approval_manager_id ===
                  (userInfoData?.uid || userInfoData?.user_id)) ||
              (expenseManagerRole === "cluster_manager" &&
                isPending &&
                row?.is_petty_cash !== 1) ||
              (isExpenseManager?.super_process_manager === 1 && isPending);

            // Super process manager can approve only (without paying)
            const canApproveOnly =
              isExpenseManager?.super_process_manager === 1 && isPending;

            // Super process manager and cluster manager can approve & pay in one step
            const canApproveAndPay =
              (expenseManagerRole === "cluster_manager" &&
                isPending &&
                row?.is_petty_cash !== 1) ||
              (isExpenseManager?.super_process_manager === 1 && isPending);

            const canInitialReject =
              (expenseManagerRole === "approval_manager" &&
                isPending &&
                row?.approval_manager_id ===
                  (userInfoData?.uid || userInfoData?.user_id)) ||
              (expenseManagerRole === "cluster_manager" &&
                isPending &&
                row?.is_petty_cash !== 1) ||
              (isExpenseManager?.super_process_manager === 1 && isPending);

            const canPay =
              (expenseManagerRole === "accountant" &&
                planStatus === "approved_notpaid") ||
              (expenseManagerRole === "cluster_manager" &&
                planStatus === "approved_notpaid" &&
                row?.is_petty_cash !== 1) ||
              (superProcessManager && planStatus === "approved_notpaid");

            const canSecondStageReject =
              ((expenseManagerRole === "approval_manager" ||
                expenseManagerRole === "accountant") &&
                planStatus === "approved_notpaid") ||
              (expenseManagerRole === "cluster_manager" &&
                planStatus === "approved_notpaid" &&
                row?.is_petty_cash !== 1) ||
              (superProcessManager && planStatus === "approved_notpaid");

            if (
              (isApproved || isRejected || isPaid) &&
              !(
                (expenseManagerRole === "cluster_manager" &&
                  planStatus === "approved_notpaid") ||
                (expenseManagerRole === "accountant" &&
                  planStatus === "approved_notpaid") ||
                (superProcessManager && planStatus === "approved_notpaid")
              )
            ) {
              return (
                <div className="detail-expense-listing__action-section">
                  <div className="detail-expense-listing__status-container">
                    <div className="detail-expense-listing__status-icon">
                      {statusInfo.icon}
                    </div>
                    <h3 className="detail-expense-listing__status-title">
                      {statusInfo.label}
                    </h3>
                    <p className="detail-expense-listing__status-description">
                      {statusInfo.description}
                    </p>
                  </div>
                </div>
              );
            }

            if (expenseManagerRole === "accountant" && isPending) {
              return (
                <div className="detail-expense-listing__action-section">
                  <div className="detail-expense-listing__pending-container">
                    <div className="detail-expense-listing__pending-icon">
                      ⏳
                    </div>
                    <h3 className="detail-expense-listing__pending-title">
                      Awaiting Approval
                    </h3>
                    <p className="detail-expense-listing__pending-description">
                      This request is currently pending approval from the
                      approval manager. Once approved, you will be able to
                      process the payment or reject the request.
                    </p>
                  </div>
                </div>
              );
            }

            if (
              canInitialApprove ||
              canInitialReject ||
              canPay ||
              canSecondStageReject
            ) {
              return (
                <div className="detail-expense-listing__action-section">
                  <div className="detail-expense-listing__action-container">
                    <h3 className="detail-expense-listing__action-title">
                      Take Action
                    </h3>

                    <div className="detail-expense-listing__remarks-container">
                      <label className="detail-expense-listing__remarks-label">
                        Remarks{" "}
                        <span className="detail-expense-listing__remarks-required">
                          *
                        </span>
                        <span className="detail-expense-listing__remarks-hint">
                          (minimum 10 characters)
                        </span>
                      </label>
                      <textarea
                        value={remarks}
                        onChange={(e) => setRemarks(e.target.value)}
                        placeholder="Enter detailed remarks for your decision..."
                        rows={3}
                        className="detail-expense-listing__remarks-textarea"
                      />
                    </div>

                    {(expenseManagerRole === "cluster_manager" ||
                      superProcessManager ||
                      canApproveOnly ||
                      canApproveAndPay) &&
                      isPending && (
                        <div className="detail-expense-listing__approval-checkbox">
                          <label className="detail-expense-listing__approval-label">
                            <input
                              type="checkbox"
                              checked={isApproving}
                              onChange={(e) =>
                                handleApprovalCheckboxChange(e.target.checked)
                              }
                              className="detail-expense-listing__approval-input"
                            />
                            <span className="detail-expense-listing__approval-text">
                              I confirm that I am approving this request
                            </span>
                          </label>
                        </div>
                      )}

                    {(canPay ||
                      canSecondStageReject ||
                      canApproveAndPay ||
                      ((expenseManagerRole === "cluster_manager" ||
                        superProcessManager) &&
                        (isPending || planStatus === "approved_notpaid"))) && (
                      <div className="detail-expense-listing__image-upload">
                        <label className="detail-expense-listing__image-label">
                          {expenseManagerRole === "cluster_manager" ||
                          superProcessManager ||
                          canApproveAndPay
                            ? "Upload Payment Proof Image / Payment Ki Photo Upload Kare"
                            : "Upload Payment Image"}{" "}
                          {(canApproveAndPay || canPay) && (
                            <span className="detail-expense-listing__image-required">
                              * (Required for payment actions)
                            </span>
                          )}
                        </label>
                        <div className="detail-expense-listing__image-upload-container">
                          <ImageUploading
                            multiple={false}
                            value={actionImages}
                            onChange={handleImageChange}
                            maxNumber={maxNumber}
                            dataURLKey="data_url"
                          >
                            {({
                              imageList,
                              onImageUpload,
                              onImageRemoveAll,
                              onImageUpdate,
                              onImageRemove,
                              isDragging,
                              dragProps,
                            }) => (
                              <div>
                                {actionImages.length === 0 ? (
                                  <div className="detail-expense-listing__image-upload-empty">
                                    <div className="detail-expense-listing__image-upload-icon">
                                      📄
                                    </div>
                                    <button
                                      type="button"
                                      className="btn btn-primary btn-sm"
                                      onClick={onImageUpload}
                                      disabled={isImageUploading}
                                      {...dragProps}
                                    >
                                      {isImageUploading
                                        ? "Uploading..."
                                        : isDragging
                                        ? "Drop image here"
                                        : "Choose Image"}
                                    </button>
                                    <div className="detail-expense-listing__image-upload-hint">
                                      {isImageUploading
                                        ? "Please wait while image is uploading..."
                                        : "Supports JPG, PNG, PDF files"}
                                    </div>
                                  </div>
                                ) : (
                                  <div className="detail-expense-listing__image-upload-selected">
                                    {imageList.map((image, index) => (
                                      <div
                                        key={index}
                                        className="detail-expense-listing__image-upload-item"
                                      >
                                        <img
                                          src={image["data_url"]}
                                          alt="Upload preview"
                                          className="detail-expense-listing__image-upload-image"
                                        />
                                        <div className="detail-expense-listing__image-upload-actions">
                                          <button
                                            type="button"
                                            className="btn btn-sm btn-secondary"
                                            onClick={() => onImageUpdate(index)}
                                          >
                                            Update
                                          </button>
                                          <button
                                            type="button"
                                            className="btn btn-sm btn-danger"
                                            onClick={() => onImageRemove(index)}
                                          >
                                            Remove
                                          </button>
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </div>
                            )}
                          </ImageUploading>
                        </div>
                      </div>
                    )}

                    <div className="detail-expense-listing__action-buttons">
                      {isPending && (
                        <>
                          {/* Super Process Manager gets both approve options */}
                          {canApproveOnly && (
                            <button
                              onClick={() =>
                                handleApproveRejectPay("approve_only")
                              }
                              disabled={!canPerformAction("approve_only")}
                              className="btn btn-primary btn-sm"
                              style={{
                                minWidth: "100px",
                                fontSize: "12px",
                                padding: "8px 16px",
                              }}
                            >
                              {isSubmitting || isImageUploading
                                ? "Processing..."
                                : "✅ Approve Only"}
                            </button>
                          )}

                          {canApproveAndPay && (
                            <button
                              onClick={() =>
                                handleApproveRejectPay("approve_and_pay")
                              }
                              disabled={!canPerformAction("approve_and_pay")}
                              className="btn btn-success btn-sm"
                              style={{
                                minWidth: "100px",
                                fontSize: "12px",
                                padding: "8px 16px",
                              }}
                            >
                              {isSubmitting || isImageUploading
                                ? "Processing..."
                                : "✅ Approve & Pay"}
                            </button>
                          )}

                          {/* Regular approve button for approval managers */}
                          {canInitialApprove &&
                            !canApproveOnly &&
                            !canApproveAndPay && (
                              <button
                                onClick={() =>
                                  handleApproveRejectPay("approve")
                                }
                                disabled={!canPerformAction("approve")}
                                className="btn btn-success btn-sm"
                                style={{
                                  minWidth: "100px",
                                  fontSize: "12px",
                                  padding: "8px 16px",
                                }}
                              >
                                {isSubmitting || isImageUploading
                                  ? "Processing..."
                                  : "✅ Approve"}
                              </button>
                            )}

                          {canInitialReject && (
                            <button
                              onClick={() => handleApproveRejectPay("reject")}
                              disabled={!canPerformAction("reject")}
                              className="btn btn-danger btn-sm"
                              style={{
                                minWidth: "100px",
                                fontSize: "12px",
                                padding: "8px 16px",
                              }}
                            >
                              {isSubmitting || isImageUploading
                                ? "Processing..."
                                : "❌ Reject"}
                            </button>
                          )}
                        </>
                      )}

                      {planStatus === "approved_notpaid" && (
                        <>
                          {canPay && (
                            <button
                              onClick={() => handleApproveRejectPay("pay")}
                              disabled={!canPerformAction("pay")}
                              className="btn btn-success btn-sm"
                              style={{
                                minWidth: "100px",
                                fontSize: "12px",
                                padding: "8px 16px",
                              }}
                            >
                              {isSubmitting || isImageUploading
                                ? "Processing..."
                                : "💰 Mark as Paid"}
                            </button>
                          )}

                          {canSecondStageReject && (
                            <button
                              onClick={() => handleApproveRejectPay("reject")}
                              disabled={!canPerformAction("reject")}
                              className="btn btn-danger btn-sm"
                              style={{
                                minWidth: "100px",
                                fontSize: "12px",
                                padding: "8px 16px",
                              }}
                            >
                              {isSubmitting || isImageUploading
                                ? "Processing..."
                                : "❌ Reject"}
                            </button>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                </div>
              );
            }
            return null;
          })()}
      </div>
    </>
  );
};

export default DetailsExpenseListing;
